import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import { REDUCER_NAME as CURRENT_REDUCER_NAME } from './reducer';
import VMGTable from './VMGTable';
import Chart from './Chart';
import Responsive from '../../../../common/responsive/Responsive';
import './VMG.scss';
import Header from '../../common/Header';
import VMGTableRanking from './VMGTableRanking';
import ConstHeader from '../../common/Const';

const LAST_TIME_RANGE = 10;

class VMG extends React.Component {
  render() {
    const {
      component = {},
      investData: { valueInvestTable },
    } = this.props;
    const lastTimeRange = valueInvestTable.find(
      time => time.timeRange === LAST_TIME_RANGE,
    );

    return (
      <div className="fiinTradeStrategy value flex-fill d-flex flex-column">
        <Header
          firstStrName={'strategy.VMGNameHeader'}
          secondStrName={'strategy.vmgNameHeader'}
          title={'strategy.vmg'}
          isShowCheckbox={true}
          color={ConstHeader.COLORVMG}
          data={lastTimeRange}
        />
        <div className="d-flex flex-fill flex-column h-100 px-20">
          <div className="mb-10">
            <Responsive
              appendClassChild="d-flex flex-fill"
              appendClass="responsive-wrapper-vmg"
              component={{
                ...component,
                width: Math.max(component.width, 400),
              }}
              margin={10}
              offsetWidth={40}
              XS_SIZE={600}
              numColumnLgSize={2}
              numColumnMdSize={2}
              ratioWidthItem={[6, 4]}
            >
              {widthC => <Chart width={widthC} />}
              {() => <VMGTable />}
            </Responsive>
          </div>
          <div className="d-flex flex-fill mb-10">
            <VMGTableRanking />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  component: state[REDUCER_NAME].component,
  investData: state[CURRENT_REDUCER_NAME].investData,
});

export default connect(mapStateToProps)(VMG);
